/* ==========================================================================
   CLARITY HEALTH CO — REVIEWS  (<clarity-reviews>)
   Fetches the store's PUBLIC Judge.me carousel feed and renders a rail of PAIRS.
   Each pair is ONE real review that HAS a customer photo: a clean image card +
   its matching text card (pill · stars · quote · name · Verified Buyer), both
   built from the SAME review object — so the photo and the words can never drift
   apart. Reviews without a valid photo are filtered out entirely (no placeholders,
   no stock imagery, no fabrication). Public params only — no API token. Review
   text is inserted with textContent (never innerHTML); photo URLs are accepted
   only from the known Judge.me review-image host. No arrows / dots / CTA.
   ========================================================================== */
(function () {
  if (customElements.get('clarity-reviews')) return;

  var ENDPOINT = 'https://cdn.judge.me/reviews/reviews_for_carousel';
  var IMG_HOST = 'review-images.judgeme.com';
  var SVGNS = 'http://www.w3.org/2000/svg';
  var STAR_D = 'M12 2l3 6.9 7.4.6-5.6 4.9 1.7 7.3L12 17.9 5.5 21.7l1.7-7.3L1.6 9.5 9 8.9z';
  var CHECK_D = 'M6 0a6 6 0 100 12A6 6 0 006 0zm2.5 4.6L5.4 7.7 3.5 5.8l.7-.7 1.2 1.2 2.4-2.4.7.7z';

  function bool(v, dflt) { if (v == null || v === '') return dflt; return v === 'true' || v === true; }

  function svg(d, cls) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('viewBox', d === CHECK_D ? '0 0 12 12' : '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  }

  function stars(rating) {
    var wrap = document.createElement('span');
    wrap.className = 'clarity-rev__stars';
    var full = Math.max(0, Math.min(5, Math.round(rating || 0)));
    for (var i = 0; i < 5; i++) wrap.appendChild(svg(STAR_D, 'clarity-rev__star' + (i < full ? '' : ' clarity-rev__star--muted')));
    return wrap;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // Accept a photo URL only from the known Judge.me host; normalise to a card width.
  function photoUrl(review, width) {
    var pics = review && review.pictures_urls;
    if (!pics || !pics.length) return null;
    var raw = pics[0].huge || pics[0].original || pics[0].compact || pics[0].small;
    if (!raw) return null;
    var u;
    try { u = new URL(raw, location.href); } catch (e) { return null; }
    if (u.protocol !== 'https:' || u.hostname !== IMG_HOST) return null;
    u.searchParams.set('quality', '80');
    u.searchParams.set('width', String(width || 900));
    return u.href;
  }

  // Short pill from real product data (flavour after a dash), else the fallback.
  function pillLabel(review, fallback) {
    var t = (review.product_title || '').trim();
    if (t) {
      var parts = t.split(/\s[—–-]\s/);
      if (parts.length > 1) {
        var last = parts[parts.length - 1].trim();
        if (last && last.length <= 24) return last;
      }
      if (!/^clarity health co\.?$/i.test(t) && t.length <= 22) return t;
    }
    return fallback;
  }

  function displayName(review) {
    var n = (review.reviewer_name || '').trim();
    if (!n || review.is_anonymous_reviewer) return 'Verified customer';
    return n;
  }

  function verifiedBadge() {
    var b = el('span', 'clarity-rev__v');
    b.appendChild(svg(CHECK_D));
    b.appendChild(document.createTextNode('Verified Buyer'));
    return b;
  }

  // LEFT: clean customer photo. No pill, no stars, no quote — image only.
  function imageCard(review) {
    var div = el('div', 'clarity-rev__media');
    var img = document.createElement('img');
    img.className = 'clarity-rev__mimg';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = 'Customer photo from ' + displayName(review);
    img.addEventListener('error', function () { div.classList.add('is-fallback'); img.remove(); });
    img.src = photoUrl(review, 900);
    div.appendChild(img);
    return div;
  }

  // RIGHT: the SAME review's words.
  function textCard(review, opts) {
    var fig = el('figure', 'clarity-rev__text');
    if (opts.showPill) fig.appendChild(el('span', 'clarity-rev__tag', pillLabel(review, opts.pillFallback)));
    fig.appendChild(stars(review.rating));
    var q = el('blockquote', 'clarity-rev__q');
    q.textContent = '“' + (review.body || '').trim() + '”';
    fig.appendChild(q);
    var foot = el('figcaption', 'clarity-rev__foot');
    foot.appendChild(el('span', 'clarity-rev__name', displayName(review)));
    if (opts.showVerified && review.verified_buyer) foot.appendChild(verifiedBadge());
    fig.appendChild(foot);
    return fig;
  }

  function pairCard(review, opts) {
    var li = el('li', 'clarity-rev__pair');
    li.setAttribute('role', 'group');
    li.appendChild(imageCard(review));   // built from the SAME review as...
    li.appendChild(textCard(review, opts)); // ...this — image + words can't drift apart
    return li;
  }

  function pointerDrag(host, rail) {
    if (!matchMedia('(pointer: fine)').matches) return;
    var down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; host.setAttribute('data-dragging', ''); }
      if (moved) { rail.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    function end() { down = false; host.removeAttribute('data-dragging'); }
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('pointerleave', end);
    rail.addEventListener('click', function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); } }, true);
  }

  function formatCount(n) { return n >= 1000 ? (Math.floor(n / 100) / 10) + 'k' : String(n); }

  class ClarityReviews extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.rail = this.querySelector('[data-rev-rail]');
      this.note = this.querySelector('[data-rev-note]');
      this.metaText = document.querySelector('[data-rev-metatext]');
      this.metaStars = document.querySelector('.clarity-rev__metastars');
      this.opts = {
        showPill: bool(this.dataset.showPill, true),
        pillFallback: (this.dataset.pillFallback || 'Hydration'),
        showVerified: bool(this.dataset.showVerified, true)
      };
      this.max = Math.max(3, parseInt(this.dataset.max, 10) || 12);
      this.load();
    }

    buildUrl() {
      var p = new URLSearchParams({
        reviews_selection: 'all',
        carousel_type: 'cards',
        star_rating: 'all',
        max_reviews: '30',
        url: this.dataset.url || ('https://' + (this.dataset.shopDomain || '')),
        shop_domain: this.dataset.shopDomain || '',
        platform: 'shopify',
        primary_language: 'en',
        display_order: this.dataset.order || 'media_first'
      });
      return ENDPOINT + '?' + p.toString();
    }

    async load() {
      var data;
      try {
        var res = await fetch(this.buildUrl(), { credentials: 'omit' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        data = await res.json();
      } catch (e) { this.fail(); return; }

      var all = (data && data.reviews) || [];
      // Only genuine photo reviews with real text and a valid Judge.me image.
      var photo = all.filter(function (r) { return r && (r.body || '').trim() && photoUrl(r, 10); });
      if (!photo.length) { this.fail(); return; }
      this.updateMeta(all);              // count line reflects ALL reviews (social proof)
      this.render(photo.slice(0, this.max));
    }

    updateMeta(reviews) {
      var rated = reviews.filter(function (r) { return r && r.rating; });
      var n = rated.length;
      var avg = n ? rated.reduce(function (a, r) { return a + r.rating; }, 0) / n : 0;
      var avgStr = (Math.round(avg * 10) / 10).toFixed(1);
      if (this.metaText && n) this.metaText.textContent = avgStr + ' · ' + formatCount(n) + '+ reviews';
      if (this.metaStars && n) {
        var fresh = stars(avg); fresh.className = 'clarity-rev__metastars';
        this.metaStars.replaceWith(fresh); this.metaStars = fresh;
      }
    }

    render(reviews) {
      var opts = this.opts;
      var frag = document.createDocumentFragment();
      reviews.forEach(function (r) { frag.appendChild(pairCard(r, opts)); });
      this.rail.replaceChildren(frag);
      this.setAttribute('data-ready', '');
      pointerDrag(this, this.rail);
    }

    fail() {
      if (this.rail) this.rail.replaceChildren();
      if (this.note) { this.note.hidden = false; this.note.textContent = 'Customer reviews are on their way.'; }
      this.setAttribute('data-empty', '');
    }
  }

  customElements.define('clarity-reviews', ClarityReviews);
})();
